(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ll-pack-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var SEL = '[data-ref="quantity-break-variant-picker"]';
    var SW = {};
    try { var el = document.querySelector('[data-ll-swatches]'); if (el) SW = JSON.parse(el.textContent); } catch (e) { SW = {}; }
    var ZOOM = { 'Pink Leopard': ['520%', '30% 42%'] };

    function parse(select) {
      var out = [];
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        var parts = o.textContent.trim().split(' / ');
        if (parts.length !== 2) return null;
        out.push({ o: o, c: parts[0].trim(), s: parts[1].trim() });
      }
      return out;
    }
    function uniq(list, key) { var seen = {}, res = []; list.forEach(function (x) { if (!seen[x[key]]) { seen[x[key]] = 1; res.push(x[key]); } }); return res; }

    function swatchStyle(btn, colour, opts) {
      var cfg = SW[colour] || {};
      if (cfg.c) { btn.style.backgroundColor = cfg.c; return; }
      var url = cfg.img;
      if (!url) { var first = opts.filter(function (x) { return x.c === colour; })[0]; url = first && first.o.dataset.variantImage; }
      if (url) {
        btn.style.backgroundImage = 'url("' + url + '")';
        if (ZOOM[colour]) { btn.style.backgroundSize = ZOOM[colour][0]; btn.style.backgroundPosition = ZOOM[colour][1]; }
      }
    }

    function sizeSelect(wrapper, sizes, current, label) {
      var w = wrapper.cloneNode(true);
      w.classList.remove('ll-split-hidden');
      var s = w.querySelector('select');
      ['data-ref', 'name', 'id', 'data-ll-split'].forEach(function (a) { s.removeAttribute(a); });
      s.setAttribute('aria-label', label);
      s.innerHTML = '';
      sizes.forEach(function (v) { var op = document.createElement('option'); op.value = v; op.textContent = v; if (v === current) op.selected = true; s.appendChild(op); });
      return { wrap: w, select: s };
    }

    function apply(ctx) {
      var c = ctx.colour, s = ctx.size.select.value, hit = null, i;
      for (i = 0; i < ctx.opts.length; i++) { if (ctx.opts[i].c === c && ctx.opts[i].s === s && !ctx.opts[i].o.disabled) { hit = ctx.opts[i]; break; } }
      if (!hit) {
        for (i = 0; i < ctx.opts.length; i++) { if (ctx.opts[i].c === c && !ctx.opts[i].o.disabled) { hit = ctx.opts[i]; break; } }
        if (hit) ctx.size.select.value = hit.s;
      }
      ctx.name.textContent = c;
      ctx.buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.colour === c ? 'true' : 'false'); });
      if (!hit || ctx.original.value === hit.o.value) return;
      ctx.original.value = hit.o.value;
      ctx.original.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function addHead(container) {
      if (!container || container.querySelector('.ll-pack-head')) return;
      var head = document.createElement('div');
      head.className = 'll-pack-head';
      head.innerHTML = '<span>Pick a colour and size for each bra</span><button type="button" data-ll-size-guide-open>Size guide</button>';
      container.insertBefore(head, container.firstChild);
    }

    function enhance(original) {
      if (original.dataset.llSplit) return;
      var opts = parse(original);
      var wrapper = original.closest('.select-wrapper');
      if (!opts || !wrapper) return;
      original.dataset.llSplit = '1';
      var row = original.closest('.quantity-break__variant-picker-row');
      var container = row && row.parentElement;
      addHead(container);
      var rows = container ? Array.prototype.slice.call(container.querySelectorAll('.quantity-break__variant-picker-row')) : [];
      var n = rows.indexOf(row) + 1;
      var sel = opts.filter(function (x) { return x.o.value === original.value; })[0] || opts[0];
      var ctx = { original: original, opts: opts, row: row, index: n, colour: sel.c, buttons: [] };

      var box = document.createElement('div');
      box.className = 'll-split';
      var label = document.createElement('div');
      label.className = 'll-split__label';
      label.innerHTML = '<span class="ll-split__n">Bra ' + (n || 1) + '</span><span class="ll-split__c"></span>';
      ctx.name = label.querySelector('.ll-split__c');
      var sw = document.createElement('div');
      sw.className = 'll-sw';
      sw.setAttribute('role', 'group');
      sw.setAttribute('aria-label', 'Colour for bra ' + (n || 1));
      uniq(opts, 'c').forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'll-sw__b'; b.dataset.colour = c; b.title = c; b.setAttribute('aria-label', c);
        var any = opts.some(function (x) { return x.c === c && !x.o.disabled; });
        if (!any) b.disabled = true;
        swatchStyle(b, c, opts);
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ctx.colour = c; apply(ctx); });
        sw.appendChild(b); ctx.buttons.push(b);
      });
      ctx.size = sizeSelect(wrapper, uniq(opts, 's'), sel.s, 'Size for bra ' + (n || 1));
      box.appendChild(label); box.appendChild(sw); box.appendChild(ctx.size.wrap);
      wrapper.classList.add('ll-split-hidden');
      wrapper.parentNode.insertBefore(box, wrapper.nextSibling);
      if (row) row._llCtx = ctx;
      ctx.name.textContent = ctx.colour;
      ctx.buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.colour === ctx.colour ? 'true' : 'false'); });

      ctx.size.select.addEventListener('change', function () {
        ctx.touched = true;
        apply(ctx);
        if (n === 1) {
          rows.slice(1).forEach(function (r) {
            var other = r._llCtx;
            if (other && !other.touched) { other.size.select.value = ctx.size.select.value; apply(other); }
          });
        }
      });
    }

    function run() { document.querySelectorAll(SEL).forEach(enhance); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ll-price-line"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(c) { c = Math.round(c); return '£' + (c % 100 === 0 ? (c / 100).toFixed(0) : (c / 100).toFixed(2)); }
    function fill(tpl, v) { return (tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; }); }

    function update() {
      var line = document.querySelector('[data-ll-price-line]');
      var qb = document.querySelector('quantity-breaks');
      if (!line || !qb) return;
      var items = Array.prototype.slice.call(qb.querySelectorAll('quantity-break-item'));
      var it = qb.querySelector('.quantity-break--selected') || items[0];
      if (!it) return;
      var idx = items.indexOf(it);
      var next = items[idx + 1];
      var q = parseInt(it.dataset.quantity, 10) || 1;
      var total = parseFloat(it.dataset.totalPrice) || 0;
      var compare = parseFloat(it.dataset.totalCompareAtPrice) || total;
      var v = { qty: q, total: money(total), unit: money(total / q), save: money(Math.max(0, compare - total)),
                extra: next ? money((parseFloat(next.dataset.totalPrice) || 0) - total) : '' };
      var d = line.dataset;
      line.querySelector('[data-ll-pl-price]').textContent = money(total);
      var cmp = line.querySelector('[data-ll-pl-compare]');
      if (compare > total) { cmp.textContent = money(compare); cmp.hidden = false; } else { cmp.hidden = true; }
      var chip = line.getAttribute(q === 1 ? 'data-chip-1' : (idx === items.length - 1 ? 'data-chip-3' : 'data-chip-2'));
      line.querySelector('[data-ll-pl-chip]').textContent = fill(chip, v);
      line.querySelector('[data-ll-pl-note]').innerHTML = fill(q === 1 ? line.getAttribute('data-note-1') : d.noteN, v);
      document.querySelectorAll('[data-ll-pack-note]').forEach(function (n) {
        var tpl = n.getAttribute(q === 1 ? 'data-note-1' : (idx === items.length - 1 ? 'data-note-last' : 'data-note-mid'));
        n.innerHTML = fill(tpl, v);
      });
      var label = q > 1 ? fill(d.ctaN, { qty: q, item: d.plural }) : null;
      document.querySelectorAll('.full-add-to-cart-text').forEach(function (s) {
        if (!s.dataset.llDefault) s.dataset.llDefault = s.textContent.trim();
        var want = label || s.dataset.llDefault;
        if (s.textContent.trim() !== want) s.textContent = want;
      });
    }

    var t;
    function soon() { clearTimeout(t); t = setTimeout(update, 40); }
    function init() {
      update();
      document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('quantity-breaks')) soon(); }, true);
      document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('quantity-breaks')) soon(); }, true);
      var qb = document.querySelector('quantity-breaks');
      if (qb) new MutationObserver(soon).observe(qb, { attributes: true, subtree: true, attributeFilter: ['class', 'data-total-price'] });
      var btns = document.querySelectorAll('[data-ref="add-to-cart-button"]');
      btns.forEach(function (b) { new MutationObserver(soon).observe(b, { childList: true, subtree: true, characterData: true }); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ll-size-finder"] && !Shopify.designMode) return;
  try {
    (function () {
    var SP = [68.6, 73.7, 78.7, 83.8, 88.9, 94.0, 99.1, 104.1, 109.2];
    var GAP = [11.4, 14.0, 16.5, 19.1, 21.6, 24.1];
    var T = [[null,null,null,'S','S'],['S','S','S','M','M'],['M','M','M','L','L'],['L','L','L','XL','XL'],['XL','XL','XL','2XL','2XL'],['2XL','2XL','2XL','3XL','3XL'],['3XL','3XL','3XL','3XL','4XL'],['4XL','4XL','4XL','4XL',null]];
    var ORDER = ['S','M','L','XL','2XL','3XL','4XL'];
    function idx(v, b) { for (var i = 0; i < b.length - 1; i++) { if (v >= b[i] - 0.3 && v < b[i + 1]) return i; } if (Math.abs(v - b[b.length - 1]) < 0.3) return b.length - 2; return -1; }
    function near(v, b) { for (var i = 1; i < b.length - 1; i++) { if (Math.abs(v - b[i]) <= 0.8) return true; } return false; }
    document.querySelectorAll('[data-ll-size-finder]').forEach(function (root) {
      root.querySelectorAll('[data-ll-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          root.querySelectorAll('[data-ll-tab]').forEach(function (t) { t.classList.toggle('ll-sf__tab--active', t === tab); });
          root.querySelectorAll('[data-ll-panel]').forEach(function (p) { p.classList.toggle('ll-sf__panel--hidden', p.dataset.llPanel !== tab.dataset.llTab); });
        });
      });
      var go = root.querySelector('[data-ll-go]'), res = root.querySelector('[data-ll-result]');
      go.addEventListener('click', function () {
        var unit = (root.querySelector('input[name="ll-sf-unit"]:checked') || {}).value || 'cm';
        var ub = parseFloat(String(root.querySelector('[data-ll-underbust]').value).replace(',', '.'));
        var bu = parseFloat(String(root.querySelector('[data-ll-bust]').value).replace(',', '.'));
        res.classList.add('is-on');
        if (isNaN(ub) || isNaN(bu)) { res.innerHTML = 'Please enter both measurements.'; return; }
        if (unit === 'in') { ub = ub * 2.54; bu = bu * 2.54; }
        if (bu <= ub) { res.innerHTML = 'Your bust measurement should be larger than your underbust. Please check both.'; return; }
        var gap = bu - ub, r = idx(ub, SP), c = gap < GAP[0] ? 0 : idx(gap, GAP);
        var size = (r >= 0 && c >= 0) ? T[r][c] : null, note = '';
        if (!size && r === 0 && c >= 0 && c < 3) { size = 'S'; note = 'S is our smallest size and the closest to your measurements.'; }
        if (!size) { res.innerHTML = 'Your measurements fall outside our chart. <a href="/pages/contact">Email us</a> and we will recommend the closest size.'; return; }
        if (!note) {
          var hesitate = near(ub, SP) || (gap >= GAP[0] && near(gap, GAP));
          var up = ORDER[ORDER.indexOf(size) + 1];
          if (c >= 3) note = up ? 'Fuller bust: if you prefer more room, choose ' + up + '.' : 'This is the largest size in our chart.';
          else if (hesitate) note = up ? 'You are close to the line between two sizes: if in doubt, choose ' + up + '.' : '';
        }
        res.innerHTML = '<div>Your size</div><strong class="ll-sf__size">' + size + '</strong><div>Underbust ' + Math.round(ub) + ' cm · difference ' + (Math.round(gap * 10) / 10) + ' cm</div>' + (note ? '<div style="margin-top:6px">' + note + '</div>' : '') + '<div style="margin-top:6px;opacity:.75">Wrong size anyway? Free Size Swap: we send the right one, you keep the first.</div>';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ll-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var open = e.target.closest && e.target.closest('[data-ll-size-guide-open]');
      var dlg = document.getElementById('ll-size-guide');
      if (open && dlg) {
        e.preventDefault(); e.stopPropagation();
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        return;
      }
      var close = e.target.closest && e.target.closest('[data-ll-sg-close]');
      if (close && dlg && dlg.open) { dlg.close(); return; }
      if (dlg && dlg.open && e.target === dlg) { var r = dlg.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close(); }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
